module.exports = __webpack_public_path__ + "img/20200707_103608.d85719e7.jpg";